module.exports = __webpack_public_path__ + "static/img/logo-m.e653553.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-m.png
// module id = VU4v
// module chunks = 3